module.exports = __webpack_public_path__ + "static/media/8.bb1fb417.jpg";